import { Color } from '../Color'
import { Spacing } from '../Spacing'
import { Elevation } from './types'
import type { ShadowStyle } from './types'

export { Elevation as ShadowElevation }

/**
 * Standard shadows.
 *
 * @example
 *   ...Shadow[ShadowElevation.E1],
 *
 * @example
 * boxShadow: someCondition
 *   ? null
 *   : Shadow[ShadowElevation.E1].boxShadow,
 *
 * @example
 * boxShadow: [
 *   Shadow[ShadowElevation.E1].boxShadow,
 *   `0 0 0 1px ${Color[theme].Surface.N000}`,
 * ].join(', '),
 */
export const Shadow: ShadowStyle = {
  [Elevation.E0]: {
    boxShadow: 'none',
  },
  [Elevation.E1]: {
    boxShadow: `0 ${Spacing.XS}px ${Spacing.XS * 2}px 0 ${
      Color.dark.Translucent.N08
    }`,
  },
  [Elevation.E2]: {
    boxShadow: `0 ${Spacing.XS * 2}px ${Spacing.XS * 5}px 0 ${
      Color.dark.Translucent.N16
    }`,
  },
  [Elevation.E3]: {
    boxShadow: `0 ${Spacing.XS * 5}px ${Spacing.XS * 10}px 0 ${
      Color.dark.Translucent.N24
    }`,
  },
} as const
